import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { useRedtailFamilyContext } from '../../../../../api/redtail'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import presets from './presets'

export default function useRedtailListPreset (presetKey, config = {}) {
  const { clientId, userId } = useAppContext()
  const familyContext = useRedtailFamilyContext(clientId)

  const preset = presets[presetKey]
  const isUserScoped = config.scope === 'user'

  const listQuery = useQuery({
    queryKey: [
      QUERY_KEYS.redtailDomainQuery, 'list-preset', userId, clientId, presetKey,
      config.scope, config.categoryIds, config.limit, config.lookaheadDays,
      config.pinnedLimit, config.recentLimit, config.priorityFilter
    ],
    queryFn: async () => {
      const members = isUserScoped ? null : familyContext.members
      const rawData = await preset.fetchData(members, clientId, config)
      return preset.compute(rawData, config)
    },
    enabled: isUserScoped
      ? !!preset
      : !!preset && familyContext.linked === true && !!familyContext.members?.length
  })

  const data = listQuery.data
  const items = Array.isArray(data) ? data : []

  const merged = useMemo(() => {
    if (!preset) return { title: 'Unknown Preset', icon: null }
    return {
      title: config.title ?? preset.defaults.title,
      icon: config.icon ?? preset.defaults.icon
    }
  }, [preset, config.title, config.icon])

  return {
    data,
    items,
    members: familyContext.members,
    isLoading: isUserScoped
      ? listQuery.isLoading
      : familyContext.isLoading || listQuery.isLoading,
    notLinked: isUserScoped ? false : familyContext.linked === false,
    error: isUserScoped
      ? listQuery.error
      : familyContext.error || listQuery.error,
    ...merged
  }
}
